<aside class="access-sidebar" [class.access-sidebar-expanded]="expanded">
  @if (expanded) {
    <nav class="sidebar-nav">
      @for (item of items; track item.label) {
        @if (item.visible !== false) {
          <div
            class="sidebar-group"
            (mouseenter)="openSubmenuOnHover(item)"
            (mouseleave)="closeSubmenuOnHover()"
          >
            @if (hasChildren(item)) {
              <button
                class="sidebar-item"
                type="button"
                (click)="toggleSubmenu(item)"
                [pTooltip]="item.label"
                tooltipPosition="right"
                [tooltipDisabled]="isSubmenuOpen(item)"
              >
                <i [class]="item.icon"></i>

                <i
                  class="pi pi-chevron-right sidebar-chevron"
                  [class.sidebar-chevron-open]="isSubmenuOpen(item)"
                ></i>
              </button>

              @if (isSubmenuOpen(item)) {
                <div class="sidebar-submenu">
                  @for (child of item.items; track child.label) {
                    @if (child.visible !== false) {
                      @if (hasGrandChildren(child)) {
                        <button
                          class="sidebar-subitem"
                          type="button"
                          (click)="toggleChildSubmenu(child, $event)"
                        >
                          <i [class]="child.icon"></i>
                          <span>{{ child.label }}</span>

                          <i
                            class="pi pi-chevron-down sidebar-subitem-chevron"
                            [class.sidebar-subitem-chevron-open]="
                              isChildSubmenuOpen(child)
                            "
                          ></i>
                        </button>

                        @if (isChildSubmenuOpen(child)) {
                          <div class="sidebar-nested-submenu">
                            @for (
                              grandChild of child.items;
                              track grandChild.label
                            ) {
                              @if (grandChild.visible !== false) {
                                <a
                                  class="sidebar-nested-subitem"
                                  [routerLink]="grandChild.routerLink"
                                  routerLinkActive="sidebar-subitem-active"
                                  [routerLinkActiveOptions]="
                                    grandChild.routerLinkActiveOptions || {
                                      exact: false,
                                    }
                                  "
                                  (click)="
                                    closeSubmenu();
                                    grandChild.command
                                      ? onCommand(grandChild, $event)
                                      : null
                                  "
                                >
                                  <i [class]="grandChild.icon"></i>
                                  <span>{{ grandChild.label }}</span>
                                </a>
                              }
                            }
                          </div>
                        }
                      } @else {
                        <a
                          class="sidebar-subitem"
                          [routerLink]="child.routerLink"
                          routerLinkActive="sidebar-subitem-active"
                          [routerLinkActiveOptions]="
                            child.routerLinkActiveOptions || { exact: false }
                          "
                          (click)="
                            closeSubmenu();
                            child.command ? onCommand(child, $event) : null
                          "
                        >
                          <i [class]="child.icon"></i>
                          <span>{{ child.label }}</span>
                        </a>
                      }
                    }
                  }
                </div>
              }
            } @else {
              <a
                class="sidebar-item"
                [routerLink]="item.routerLink"
                routerLinkActive="sidebar-item-active"
                [routerLinkActiveOptions]="
                  item.routerLinkActiveOptions || { exact: false }
                "
                (click)="item.command ? onCommand(item, $event) : null"
                [pTooltip]="item.label"
                tooltipPosition="right"
              >
                <i [class]="item.icon"></i>
              </a>
            }
          </div>
        }
      }
    </nav>
  }
</aside>
